const SDK_VERSION = '7.29.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
